import { render, staticRenderFns } from "./SSOLoginButton.vue?vue&type=template&id=49c7e865&scoped=true"
import script from "./SSOLoginButton.vue?vue&type=script&lang=js"
export * from "./SSOLoginButton.vue?vue&type=script&lang=js"
import style0 from "./SSOLoginButton.vue?vue&type=style&index=0&id=49c7e865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7e865",
  null
  
)

export default component.exports